import {inject, Injectable} from '@angular/core';
import {DEFAULT_LANGUAGE} from './languages.service';
import Keycloak from 'keycloak-js';
import {DEFAULT_DATE_FORMAT} from './date-format.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {

  private readonly keycloak = inject(Keycloak);


  public getUserToken(): UserToken {
    const tokenParsed = this.keycloak.tokenParsed;

    return {
      token: this.keycloak.token,
      data: {
        id: tokenParsed['userId'],
        username: tokenParsed['preferred_username'],
        dateFormat: tokenParsed['dateFormat'] ?? DEFAULT_DATE_FORMAT,
        language: tokenParsed['language'] ?? DEFAULT_LANGUAGE,
        darkTheme: tokenParsed['darkTheme'],
        termsChecked: tokenParsed['eulaStatus'],
      },
    };
  }


  public logout(): Promise<void> {
    return this.keycloak.logout();
  }

}

export interface UserToken {
  token: string;

  data: {
    id: number;
    username: string;
    language: string;
    dateFormat: string;
    darkTheme: boolean;
    termsChecked: boolean;
  };
}
